<template>
  <div class="app-container">
    <div
      ref="filterContainer"
      class="filter-container"
    >
      <!-- 后退、前进、设置列 -->
      <table-operation2
        :init-table-column="masterList.initTableColumn"
        :table-columns.sync="masterList.tableColumns"
        :table-key="masterList.tableKey"
        :table-index.sync="masterList.tableIndex"
        :search-condition.sync="masterList.tableQuery"
        :table-transfer-name="getTransferName()"
        @reloadData="requestData()"
      />
    </div>
    <div class="container-box">
      <!-- 查询条件 -->
      <div ref="searchCondition">
        <el-row :gutter="10">
          <el-col style="width:40px;padding-left:10px;">
            <el-button type="text">
              查询：
            </el-button>
          </el-col>
          <el-col :span="3">
            <el-input
              v-model="masterList.tableQuery.tagName"
              placeholder="请输入标签名称"
              style="width:100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col :span="2">
            <el-button
              type="primary"
              @click="searchData()"
            >
              查询
            </el-button>
          </el-col>
        </el-row>
      </div>
      <!-- 数据列表 -->
      <custom-table2
        :ref="masterList.tableKey"
        style="margin-top:5px; padding: 0 2px;"
        :data-obj="masterList"
        :table-key="masterList.tableKey"
        :table-columns="masterList.tableColumns"
        :table-data="masterList.tableData"
        :loading="masterList.tableLoading"
        :search-condition.sync="masterList.tableQuery"
        :data-total="masterList.tableDataTotal"
        :table-contextmenu="masterList.tableContextmenu"
        :table-custom-height="tableHeight"
        is-index-field
        is-paging
        @reloadData="loadTableData()"
        @add="addFun"
        @edit="editFun(arguments)"
        @stop="stopFun(arguments)"
        @start="startFun(arguments)"
        @view="viewFun(arguments)"
        @dblclick="viewFun(arguments)"
        @export="batchExport(masterList)"
      />
    </div>

    <!-- 新增 修改-->
    <add-edit-view-dialog
      :data-id="id"
      :event-type="eventType"
      :dialog-title="dialogAddEditTitle"
      :dialog-visible.sync="dialogAddEditVisible"
      :master-table-key="masterList.tableKey"
      @reloadData="loadTableData()"
    />
  </div>
</template>

<script>
// Table操作组件（后退、前进、列设置）
import TableOperation2 from '@/components/TableOperation2'
// 列表设置tableKeyMixin
import tableOperationMixin2 from '@/mixin/tableOperationMixin2'
// 导出 batchExportMixin
import batchExportMixin2 from '@/mixin/batchExportMixin2'
// 自定义Table
import CustomTable2 from '@/components/CustomTable2'
// 定义表头颜色，高度，查询，获取数据Mixin
import tableCustomMixin2 from '@/mixin/tableCustomMixin2'
// 新增 修改
import addEditViewDialog from './components/addEditViewDialog'
// 零售户标签API
import { loadStoreTagListDataApi, exportStoreTagListDataApi, updateStatusStoreTagApi } from '@/api/v2/storeTag'

export default {
  name: 'StoreTagView',
  components: { CustomTable2, TableOperation2, addEditViewDialog },
  mixins: [tableCustomMixin2, tableOperationMixin2, batchExportMixin2],
  data() {
    return {
      // 主列表
      masterList: {
        initTableColumn: [], // Table初始化列
        tableColumns: [], // Table列
        tableKey: 'base_store_tag_master', // Table Key
        tableIndex: 0, // Table Index
        tableLoading: false, // Table加载状态
        tableData: [], // Table数据
        tableDataTotal: 0, // Table总数据条数
        // Table右键
        tableContextmenu: [
          {
            permissionSigns: ['store_tag_add'],
            prop: 'add',
            label: '新增',
            method: 'add'
          },
          {
            permissionSigns: ['store_tag_edit'],
            prop: 'edit',
            label: '修改',
            method: 'edit'
          },
          {
            permissionSigns: ['store_tag_stop'],
            prop: 'stop',
            label: '停用',
            method: 'stop'
          },
          {
            permissionSigns: ['store_tag_start'],
            prop: 'start',
            label: '启用',
            method: 'start'
          },
          {
            permissionSigns: ['store_tag_view'],
            prop: 'view',
            label: '查看',
            method: 'view'
          },
          {
            permissionSigns: ['store_tag_export'],
            prop: 'export',
            label: '导出',
            method: 'export'
          }
        ],
        tableQuery: {
          // 页数
          page: 1,
          // 每页条数
          limit: 50,
          // 右键筛选字段
          contextMenuWrap: [],
          // 排序字段
          sortProp: '',
          // 排序类型
          sortOrder: '',
          // 查询条件
          tagName: ''
        },
      },
      id: null,
      dialogAddEditVisible: false,
      dialogAddEditTitle: '',
      eventType: ''
    }
  },
  created() {
    let _this = this;
    // 初始化主列表Table列
    _this.masterList.initTableColumn = [
      { prop: 'rowNumber', label: '序号', width: 80 },
      { prop: 'provinceName', label: '所属省区', filterColumn: 'province_name', width: 120 },
      { prop: 'name', label: '名称', width: 200 },
      { prop: 'remark', label: '备注' },
      { prop: 'statusValue', label: '状态', filterColumn: 'status', filterValue: 'status', filterArray: [{ label: '启用', value: 1 }, { label: '停用', value: 2 }], width: 90 },
      { prop: 'operatorName', filterColumn: 'operator_name', label: '操作人', width: 120 },
      { prop: 'operationTime', filterColumn: 'operation_time', label: '操作时间', width: 150, isBetween: true }
    ]
    // 默认主列表Table列
    _this.getInitTableColumns()
    _this.loadTableData()
  },
  methods: {
    // 请求数据
    requestData() {
      let _this = this;
      loadStoreTagListDataApi(_this.masterList.tableQuery).then(response => {
        const { data } = response;
        _this.handleData(data.list || [])
        _this.masterList.tableDataTotal = data.total || 0
      }).catch()
    },
    //新增
    addFun() {
      let _this = this;
      _this.eventType = 'add'
      _this.dialogAddEditTitle = '新增零售户标签'
      _this.dialogAddEditVisible = !_this.dialogAddEditVisible
    },
    // 修改
    editFun(args) {
      let _this = this;
      if (!args[0]) {
        _this.$message({ message: '请选择要修改的零售户标签', type: 'warning' })
        return
      }
      _this.id = args[0].id
      _this.eventType = 'edit'
      _this.dialogAddEditTitle = '修改零售户标签'
      _this.dialogAddEditVisible = !_this.dialogAddEditVisible
    },
    // 查看
    viewFun(args) {
      let _this = this;
      if (!args[0]) {
        _this.$message({ message: '请选择要查看的零售户标签', type: 'warning' })
        return
      }
      _this.id = args[0].id
      _this.eventType = 'view'
      _this.dialogAddEditTitle = '查看零售户标签'
      _this.dialogAddEditVisible = !_this.dialogAddEditVisible
    },
    // 停用
    stopFun(args) {
      let _this = this;
      if (!args[0]) {
        _this.$message({ message: '请选择要停用的零售户标签', type: 'warning' })
        return
      } else if (args[0].status === 2) {
        _this.$message({ message: '零售户标签不在启用状态，不能停用', type: 'warning' })
        return
      }
      _this.$confirm('是否确定停用该零售户标签？', '系统提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', center: true }).then(async () => {
        updateStatusStoreTagApi({ id: args[0].id, status: 2 }).then(() => {
          _this.$message({ message: '停用成功', type: 'success' })
          _this.loadTableData()
        })
      }).catch(() => { })
    },
    // 启用
    startFun(args) {
      let _this = this;
      if (!args[0]) {
        _this.$message({ message: '请选择要启用的零售户标签', type: 'warning' })
        return
      } else if (args[0].status === 1) {
        _this.$message({ message: '零售户标签不在停用状态，不能启用', type: 'warning' })
        return
      }
      _this.$confirm('是否确定启用该零售户标签？', '系统提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', center: true }).then(async () => {
        updateStatusStoreTagApi({ id: args[0].id, status: 1 }).then(() => {
          _this.$message({ message: '启用成功', type: 'success' })
          _this.loadTableData()
        })
      }).catch(() => { })
    },
    // 导出数据API
    exportByPage() {
      let _this = this;
      exportStoreTagListDataApi(_this.exportObj).then((response) => {
        const { data } = response
        _this.$store.dispatch('message/settingExportSuccess', { exportSuccess: data.createFileResult, url: data.filePath })
      })
    }
  }
}
</script>
